import $ from 'jquery';

function preventDefaultIfLink(event) {
    if (event.target.tagName.toLowerCase() === 'a') {
        event.preventDefault();
    }
}

function ToggleRemote(trigger, target, options) {
    this.$trigger = $(trigger);
    this.$target = $(target);
    this.options = $.extend(ToggleRemote.defaults, options || {});

    this.$trigger.on('click', e => {
        preventDefaultIfLink(e);

        this.toggle();
    });
}

ToggleRemote.prototype.toggle = function() {
    this.$target[this.options.animate ? 'slideToggle' : 'toggle']();
    this.$trigger.toggleClass(this.options.toggleRemoteClass);
};

ToggleRemote.defaults = {
    animate: true,
    toggleRemoteClass: 'toggle-remote-expanded'
};

$.fn.toggleRemote = function(target, options) {
    return this.each(function(index, element) {
        if (!$.data(element, 'toggleRemote')) {
            $.data(element, 'toggleRemote', new ToggleRemote(element, target, options));
        }
    });
};

export function bindToggleRemote(){
    $(document).on('click', '[data-toggle-remote]', function(e) {
        preventDefaultIfLink(e);

        var $trigger = $(e.target),
            data = $trigger.data();

        ToggleRemote.prototype.toggle.call({
            $trigger: $trigger,
            $target: $(data.toggleRemote),
            options: {
                animate: 'animate' in data ? data.animate : ToggleRemote.defaults.animate,
                toggleRemoteClass:
                    'toggleRemoteClass' in data ? data.toggleRemoteClass : ToggleRemote.defaults.toggleRemoteClass
            }
        });
    });
}

export default ToggleRemote;
